// extracted by mini-css-extract-plugin
export default {"container":"style_container__i5Yjk","content":"style_content__tJLD-","title":"style_title__esK6G","title_header":"style_title_header__qSwhe","title_inner":"style_title_inner__MCfP4"};